module.exports = __webpack_public_path__ + "img/2ef_Events.719b2ba0.png";